export default "__VITE_ASSET__CDQg4ORq__"